import { bookingDayOf } from "@shyne/shared";
import { addDays, startOfDay } from "date-fns";
import type { ApiClient, Appointment } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
import { appointment_status } from "@/models/appointment.model";
import { isCancellable } from "./appointment-cancellation";
import { calendarDay } from "./appointment-reschedule";

export const GO_BACK_STATUSES: readonly appointment_status[] = [appointment_status.done, appointment_status.completed];

export const isGoBackable = (status: appointment_status): boolean => GO_BACK_STATUSES.includes(status);

export const chatStatusChoices = (status: appointment_status): appointment_status[] => [
  ...(isCancellable(status) ? [appointment_status.cancelled] : []),
  ...(isGoBackable(status) ? [appointment_status.goback] : []),
];

export const isGoBackDay = (day: Date, now: Date = new Date()): boolean => calendarDay(day) >= bookingDayOf(now);

export const firstGoBackDay = (now: Date = new Date()): Date => addDays(startOfDay(now), 1);

type GoBackApi = Pick<ApiClient["appointments"], "requestGoBack">;

export type GoBackAsked = { date: string; reasons?: string; actingOrganization: uuid | null };

export function createGoBackRequest(api: GoBackApi) {
  return function requestGoBack(id: uuid, { date, reasons, actingOrganization }: GoBackAsked): Promise<Appointment> {
    const given = reasons?.trim();
    return api.requestGoBack(id, { date, ...(given ? { reasons: given } : {}), ...(actingOrganization ? { actingOrganization } : {}) });
  };
}
